import React from 'react'

import { useIsOwner, useLoggedUser } from '@btime/react-session'
import { useModalData } from '../../../components/modals/ModalsContext'
import { useSaveUser } from './_requests/saveUser'
import { useUser } from './_load/UserLoader'
import FieldValuesFormSection from '../../../containers/fieldValues/form/FieldValuesFormSection'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import { isEmpty } from 'lodash'
import { formatLocalTime } from '../../../utils/helpers/date'

const EditUserForm = () => {
  const { initialState, id: editedUserId } = useModalData() || {}
  const user = useUser()
  const loggedUser = useLoggedUser()
  const isOwner = useIsOwner()
  const canEditSignature = editedUserId === loggedUser?.id || isOwner
  const [onSubmit, { loading, error }] = useSaveUser()

  const formatInitialState = initialState => {
    if (isEmpty(initialState)) return initialState
    if (!initialState.contract) return initialState

    const genWorkShifts = initialState => {
      if (initialState.contract.workShifts) {
        return initialState.contract.workShifts.map(workShift => {
          return workShift.map(workShift => {
            if (isEmpty(workShift)) return workShift
            return {
              start: formatLocalTime(workShift.start),
              end: formatLocalTime(workShift.end)
            }
          })
        })
      } else {
        initialState.contract.workShifts = []
      }
    }

    initialState.contract.workShifts = genWorkShifts(initialState)
    return initialState
  }

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={formatInitialState(user || initialState || {})}>
      <GeneralSection />
      <FieldValuesFormSection canEditSignature={canEditSignature} origin="contracts" path={['contract', 'fieldValues']} />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditUserForm
